export const Data = [
    {
        "name": "Ian Devling",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/cto.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CTO office",
        "tags": "Ceo,tag1,manager,cto",
        "isLoggedUser": "false",
        "positionName": "Chief Executive Officer ",
        "id": "O-6066",
        "parentId": "",
        "size": "",
        "_pagingStep": 2000,
        "_directSubordinatesPaging": 4,
        "_directSubordinates": 4,
        "_totalSubordinates": 1515,
        "_expanded": false,
        "_centered": null,
        "_centeredWithDescendants": null
    },
    {
        "name": "Davolio Nancy",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/general.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "CTO ",
        "id": "O-6067",
        "parentId": "O-6066",
        "size": "",
        "_pagingStep": 2000,
        "_pagingButton": false,
        "_directSubordinatesPaging": 9,
        "_directSubordinates": 9,
        "_totalSubordinates": 812,
        "_expanded": false
    },
    {
        "name": " Leverling Janet",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/female.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "CTO ",
        "id": "O-6068",
        "parentId": "O-6066",
        "size": "",
        "_pagingStep": 2000,
        "_pagingButton": false,
        "_directSubordinatesPaging": 3,
        "_directSubordinates": 3,
        "_totalSubordinates": 413,
        "_expanded": false
    },
    {
        "name": " Leverling Janet",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/female.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "CTO ",
        "id": "O-6069",
        "parentId": "O-6066",
        "size": "",
        "_pagingStep": 2000,
        "_pagingButton": false,
        "_directSubordinatesPaging": 3,
        "_directSubordinates": 3,
        "_totalSubordinates": 142,
        "_expanded": false
    },
    {
        "name": " Leverling Janet",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/female.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "CTO ",
        "id": "O-6070",
        "parentId": "O-6066",
        "size": "",
        "_pagingStep": 2000,
        "_pagingButton": false,
        "_directSubordinatesPaging": 3,
        "_directSubordinates": 3,
        "_totalSubordinates": 144,
        "_expanded": false
    },
    {
        "name": "West Adam",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/general.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "CTO",
        "id": "O-6077",
        "parentId": "O-6067",
        "size": "",
        "_pagingButton": false,
        "_directSubordinatesPaging": 0,
        "_directSubordinates": 0,
        "_totalSubordinates": 0,
        "_expanded": false
    },
    {
        "name": "Charlotte Cooper",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/general.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "Senior Trader",
        "id": "O-6078",
        "parentId": "O-6067",
        "size": "",
        "_pagingStep": 2000,
        "_pagingButton": false,
        "_directSubordinatesPaging": 1,
        "_directSubordinates": 1,
        "_totalSubordinates": 25,
        "_expanded": false
    },
    {
        "name": "Yoshi Nagase",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/general.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "Head of laboratory",
        "id": "O-6079",
        "parentId": "O-6067",
        "size": "",
        "_pagingStep": 2000,
        "_pagingButton": false,
        "_directSubordinatesPaging": 4,
        "_directSubordinates": 4,
        "_totalSubordinates": 4,
        "_expanded": false
    },
    {
        "name": "Peter Wilson",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/general.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "Head of channels",
        "id": "O-6080",
        "parentId": "O-6068",
        "size": "",
        "_pagingStep": 2000,
        "_pagingButton": false,
        "_directSubordinatesPaging": 9,
        "_directSubordinates": 9,
        "_totalSubordinates": 272,
        "_expanded": false
    },
    {
        "name": "Carlos Diaz",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/general.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "Senior Android Developer",
        "id": "O-6081",
        "parentId": "O-6068",
        "size": "",
        "_pagingStep": 2000,
        "_pagingButton": false,
        "_directSubordinatesPaging": 9,
        "_directSubordinates": 9,
        "_totalSubordinates": 136,
        "_expanded": false
    },
    {
        "name": "Sven Petersen",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/general.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "Senior Developer",
        "id": "O-6082",
        "parentId": "O-6068",
        "size": "",
        "_pagingStep": 2000,
        "_pagingButton": false,
        "_directSubordinatesPaging": 2,
        "_directSubordinates": 2,
        "_totalSubordinates": 2,
        "_expanded": false
    },
    {
        "name": "Peter Wilson",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/general.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "Head of channels",
        "id": "O-6083",
        "parentId": "O-6069",
        "size": "",
        "_pagingStep": 2000,
        "_pagingButton": false,
        "_directSubordinatesPaging": 1,
        "_directSubordinates": 1,
        "_totalSubordinates": 1,
        "_expanded": false
    },
    {
        "name": "Carlos Diaz",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/general.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "Senior Android Developer",
        "id": "O-6084",
        "parentId": "O-6069",
        "size": "",
        "_pagingStep": 2000,
        "_pagingButton": false,
        "_directSubordinatesPaging": 9,
        "_directSubordinates": 9,
        "_totalSubordinates": 136,
        "_expanded": false
    },
    {
        "name": "Sven Petersen",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/general.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "Senior Developer",
        "id": "O-6085",
        "parentId": "O-6069",
        "size": "",
        "_pagingStep": 2000,
        "_pagingButton": false,
        "_directSubordinatesPaging": 2,
        "_directSubordinates": 2,
        "_totalSubordinates": 2,
        "_expanded": false
    },
    {
        "name": "Peter Wilson",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/general.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "Head of channels",
        "id": "O-6086",
        "parentId": "O-6070",
        "size": "",
        "_pagingStep": 2000,
        "_pagingButton": false,
        "_directSubordinatesPaging": 1,
        "_directSubordinates": 1,
        "_totalSubordinates": 1,
        "_expanded": false
    },
    {
        "name": "Carlos Diaz",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/general.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "Senior Android Developer",
        "id": "O-6087",
        "parentId": "O-6070",
        "size": "",
        "_pagingStep": 2000,
        "_pagingButton": false,
        "_directSubordinatesPaging": 2,
        "_directSubordinates": 2,
        "_totalSubordinates": 138,
        "_expanded": false
    },
    {
        "name": "Sven Petersen",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/general.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "Senior Developer",
        "id": "O-6088",
        "parentId": "O-6070",
        "size": "",
        "_pagingStep": 2000,
        "_pagingButton": false,
        "_directSubordinatesPaging": 2,
        "_directSubordinates": 2,
        "_totalSubordinates": 2,
        "_expanded": false
    },
    {
        "name": " Leverling Janet",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/female.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "CTO ",
        "id": "O-6098",
        "parentId": "O-6081",
        "size": "",
        "_pagingStep": 2000,
        "_pagingButton": false,
        "_directSubordinatesPaging": 3,
        "_directSubordinates": 3,
        "_totalSubordinates": 8,
        "_expanded": false
    },
    {
        "name": "Fuller Andrew",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/general.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "Linear Manager",
        "id": "O-6099",
        "parentId": "O-6081",
        "size": "",
        "_pagingButton": false,
        "_directSubordinatesPaging": 0,
        "_directSubordinates": 0,
        "_totalSubordinates": 0,
        "_expanded": false
    },
    {
        "name": "Peacock Margaret",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/general.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "CEO",
        "id": "O-6100",
        "parentId": "O-6081",
        "size": "",
        "_pagingButton": false,
        "_directSubordinatesPaging": 0,
        "_directSubordinates": 0,
        "_totalSubordinates": 0,
        "_expanded": false
    },
    {
        "name": "Buchanan Steven",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/general.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "Head of direction",
        "id": "O-6101",
        "parentId": "O-6081",
        "size": "",
        "_pagingButton": false,
        "_directSubordinatesPaging": 0,
        "_directSubordinates": 0,
        "_totalSubordinates": 0,
        "_expanded": false
    },
    {
        "name": "Suyama Michael",
        "imageUrl": "https://raw.githubusercontent.com/bumbeishvili/Assets/master/Projects/D3/Organization%20Chart/general.jpg",
        "area": "Corporate",
        "profileUrl": "http://example.com/employee/profile",
        "office": "CEO office",
        "tags": "Ceo,tag1, tag2",
        "isLoggedUser": "false",
        "positionName": "Senior sales manager",
        "id": "O-6102",
        "parentId": "O-6081",
        "size": "",
        "_pagingButton": false,
        "_directSubordinatesPaging": 0,
        "_directSubordinates": 0,
        "_totalSubordinates": 0,
        "_expanded": false
    }
]